export default __webpack_public_path__ + "static/media/A5_EN_ORI.bcb5edbe.png";